//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('activityTypeDevTypes', {
//        templateUrl: 'views/components/views/activityTypeDevTypes/activityTypeDevTypes.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'activityTypeDevTypesService', function ($stateParams, utilityService, activityTypeDevTypesService) {
//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                setting: {},
//                itemsListDeviationTypes: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await activityTypeDevTypesService.getSetting({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];

//                return loadDeviationTypes();
//            }

//            async function loadDeviationTypes() {
//                if (utilityService.validateParmsValue(vm.model.setting.argtype) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.argvalue) !== true) return;

//                return vm.model.itemsListDeviationTypes = await activityTypeDevTypesService.listDeviationTypes({
//                    argtype: vm.model.setting.argtype,
//                    argvalue: vm.model.setting.argvalue
//                });
//            }

//            vm.$onInit = function () {
//                loadSetting();
//            }
//		}]
//	});
//})();
